<template>
  <div>
    <h1 style="margin-top: 60px; margin-bottom: 30px">Privacy Policy</h1>
    <div class="corner">
      <div class="content">
        <br/>
        <strong>App:</strong> D-Day Counter
        <br/>
        <strong>Effective date:</strong> June 17, 2026
        <br/>
        <br/>

        <strong>Overview</strong>
        <br/>
        D-Day Counter lets you track the days remaining until — or passed since — important dates, with a home-screen widget and reminders. The app does not require an account or sign-in. The events you create are stored only on your device.
        <br/>
        <br/>

        <strong>Information We Collect</strong>
        <br/>
        Advertising identifier only. The app itself does not collect names, emails, precise location, contacts, photos, or any other personal data. We do not operate a login or user account, and we do not run a server that receives your data. The only identifier involved is the advertising ID used by our ads provider (see “Advertising” below).
        <br/>
        <br/>

        <strong>Your D-Day Data Stays on Your Device</strong>
        <br/>
        The event titles, dates, repeat settings, and reminder preferences you enter are saved locally on your device only. They are shown in the app, in the home-screen widget, and in the notifications you choose to enable. This data is never transmitted off your device, and it is removed when you delete the event or uninstall the app.
        <br/>
        <br/>

        <strong>Notifications</strong>
        <br/>
        With your permission (POST_NOTIFICATIONS on Android 13+), the app posts reminders for your events — on the day and/or a chosen number of days before — and an optional always-on notification that keeps a date pinned. All notification content is generated on your device from the events you created. The app does not read, access, or transmit notifications from other apps.
        <br/>
        <br/>

        <strong>Home-Screen Widget</strong>
        <br/>
        The widget displays a date you select and updates its day count on your device. No data is sent off the device to power the widget.
        <br/>
        <br/>

        <strong>Advertising</strong>
        <br/>
        The app shows ads provided by Google AdMob. Google may use an advertising identifier to serve and measure ads. This processing is governed by Google’s Privacy Policy: https://policies.google.com/privacy
        <br/>
        <br/>

        <strong>Sharing</strong>
        <br/>
        We do not sell your data and do not use it for cross-app tracking by ourselves. Advertising data is processed by Google AdMob under Google’s terms and privacy policy.
        <br/>
        <br/>

        <strong>Retention &amp; Deletion</strong>
        <br/>
        Because your events are stored locally, you control them directly: delete an event in the app, clear the app’s storage, or uninstall the app to remove the data from your device. For advertising identifiers, you can reset or limit ad personalization in your device’s settings.
        <br/>
        <br/>

        <strong>Children</strong>
        <br/>
        The app is intended for a general audience and is not directed to children.
        <br/>
        <br/>

        <strong>International</strong>
        <br/>
        Advertising may be processed by Google on servers outside your country, as described in Google’s Privacy Policy.
        <br/>
        <br/>

        <strong>Changes</strong>
        <br/>
        We may update this policy and will post the new version with a new effective date.
        <br/>
        <br/>

        <strong>Contact</strong>
        <br/>
        evidence.erae@gmail.com
        <br/>
        <br/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {}
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.corner {
  margin: 30px;
  border-radius: 10px;
  border: 2px solid #ffffff;
  background-color: #ffffff;
  padding: 10px;
  text-align: left;
}

.content {
  padding: 0 0 0 10px;
  margin: 0 0;
  text-align: left;
}

h1 {
  text-align: center;
}

h2 {
  text-align: left;
  font-size: 13px;
  color: #aaaaaa;
  padding-bottom: 15px;
}

h3 {
  text-align: center;
  margin: 3px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

</style>
